<template>
  <div class="result-content">
    <div class="up-part">
      <p class="title">已支付</p>
      <p class="summary">已成功支付药费，请等待药房配送。</p>
      <p class="summary">您可以使用<button @click="openApp">家庭中医馆</button>查看药品订单详情及状态。</p>
    </div>
    <div class="down-part">
      <img class="matching" src="../../assets/images/order/matching.png" alt="">
      <button class="download" @click="openApp">立即下载</button>
      <p class="look-qcode" @click="showqrcode = true">查看二维码</p>
    </div>
    <div class="right_top" v-show="showalert">
      <img src="../../assets/images/download/guide.png" class="guide" alt="">
      <img src="../../assets/images/download/close_guide.png" @click="showalert=false" class="close_guide" alt="">
    </div>
    <div class="qrcode_content" v-show="showqrcode" >
      <div class="qrcode"></div>
      <p>使用浏览器扫一扫，即可下载app</p>
    </div>
    <div class="phone_bg" v-show="showalert"></div>
    <div class="phone_bg" v-show="showqrcode" @click="showqrcode=false"></div>
  </div>
</template>
<script>
import {deviceType} from '../../util/deviceType'
import CallApp from "callapp-lib";
import http from "../../util/pontusApiConfig";
export default {
  data() {
    return {
      order_id: 1,
      showqrcode: false,
      showalert: false,
      out_trade_no:localStorage.getItem("out_trade_no"),
      is_weixin: deviceType.isWeiXin,
      is_ios_app: deviceType.isIOSApp,
      is_android_app: deviceType.isAndroidApp
    }
  },
  created() {
    this.user_id = localStorage.getItem("user_id")
    if(this.out_trade_no){
      this.getreturn()
    }
  },
  methods: {
    getreturn(){
      let that = this
      let url = 'users/'+this.user_id+'/order'
      let params = {
        out_trade_no:this.out_trade_no
      }
      if(this.is_ios_app){
        params['channel'] = 'ios';
      }else if(this.is_android_app){
        params['channel'] = 'android';
      }else{
        params['channel'] = 'wap';
      }
      console.log(params)
      http.get(url,{params}, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: this.token,
          }})
      .then(function(res){
        if(res.data.status_code == 200){
          localStorage.removeItem("out_trade_no")
          that.order_id = res.data.data.order_id
        }
      })
    },
    openApp() {
      if(this.is_weixin){
        this.showalert = true;
      }else{
        const options = {
          scheme: { protocol: "haiwei" }, //要打开的 APP 的标识
          intent: {
            package: "com.haiwei.medicine_family", //包名
            scheme: "haiwei",
          },
          //apple store
          appstore: "https://apps.apple.com/cn/app/xxx/xxxx",
          //应用宝
          yinyongbao:
            "https://sj.qq.com/myapp/detail.htm?apkName=com.xxxx.bloodpressure",
          fallback: "http://d.firim.info/q5l2", //唤端失败后跳转的地址
        };
        const callLib = new CallApp(options);
        callLib.open({
          path: "",
          param: {
            "order_id": this.order_id
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.result-content{
  .up-part{
    padding: 10px 20px 27px 20px;
    .title{
      margin-bottom: 5px;
      padding-left: 49px;
      line-height: 36px;
      font-size: 24px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: #AC4B38;
      text-align: left;
      position: relative;
    }
    .title::before{
      content: '';
      display: block;
      width: 36px;
      height: 36px;
      background: url('../../assets/images/order/finished.png') no-repeat;
      background: none\9;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/order/finished.png',sizingMethod='scale');
      -webkit-background-size: 36px 36px;
      -moz-background-size: 36px 36px;
      background-size: 36px 36px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
    .summary{
      line-height: 20px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #999999;
      text-align: left;
      button{
          color: #AC4B38;
          text-decoration: underline;
      }
    }
  }
  .down-part{
    width: 100%;
    box-sizing: border-box;
    padding: 25px 24px 42px 24px;
    box-sizing: border-box;
    background: url('../../assets/images/order/bg.png') no-repeat;
    background-size: auto;
    background: none\9;
    .matching{
      width: 100%;
    }
    .download{
      margin: 30px auto 0;
      display: block;
      width: 210px;
      line-height: 48px;
      font-size: 18px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #FFFFFF;
      background: #AC4B38;
      box-shadow: 8px 8px 10px 0px rgba(85,16,2,0.15);
      border-radius: 10px;
    }
    .look-qcode{
      margin-top: 28px;
      line-height: 25px;
      font-size: 18px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #666666;
      text-align: center;
    }
  }
  .right_top {
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 10;
    .guide{
      width: 100%;
    }
    .close_guide{
      width: 100px;
      display: block;
      margin: 0 auto;
      margin-top: 30px;
    }
    .rt_img {
      width: 57px;
      height: 45px;
      position: absolute;
      right: 10px;
      top: 0;
    }
    .rt_text {
      margin-top: 60px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
    }
  }
  .phone_bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.6);
  }
  .qrcode_content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    // width: calc(100% - 75px);
    width: 300px;
    background: #fff;
    border-radius: 10px;
    border: 1px solid transparent;
    padding-top: 13px;
    .qrcode{
      width: 273px;
      height: 273px;
      margin: 0 auto;
      background: url('../../assets/images/download/qrcode2.png') no-repeat center center;
      background-size: 100% 100%;
    }
    p{
      margin-top: 12px;
      margin-bottom: 15px;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderresult.vue